import { render, staticRenderFns } from "./ProductVideo.vue?vue&type=template&id=17fec2d8&scoped=true&"
import script from "./ProductVideo.vue?vue&type=script&lang=js&"
export * from "./ProductVideo.vue?vue&type=script&lang=js&"
import style0 from "./ProductVideo.vue?vue&type=style&index=0&id=17fec2d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17fec2d8",
  null
  
)

export default component.exports